module.exports = __webpack_public_path__ + "static/img/bos-frances-swing.8f80f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bos-frances-swing.jpg
// module id = 189
// module chunks = 0